import { ICollapsibleItemProps } from '../collapsible-types';
import styled from 'styled-components';
import { ContentLayer } from '../../layers';

export const CollapsibleItemContent = styled(ContentLayer).attrs((props: Pick<ICollapsibleItemProps, 'isExpanded' | 'maxContentHeight'>) => ({
    className: String('ap-collapsible-itemContent'),
    isExpanded: props.isExpanded,
    maxContentHeight: props.maxContentHeight
})) <{ $arrowPosition?: 'start' | 'end' }>`
    min-height: ${({ isExpanded }) => (isExpanded ? '10px' : '0')};
    overflow: auto;
    height: auto;
    border-radius: ${({ theme: { collapsible: { composites } } }) => composites.itemContentBorderRadius};
    padding: ${({ $arrowPosition, theme: { semantics: { gap } } }) => `${gap.xl} ${gap.xxl} ${gap.l} ${$arrowPosition === 'start' ? '46px' : gap.xxl}`};
    max-height: ${({ maxContentHeight }) =>
        (maxContentHeight !== undefined ? `${maxContentHeight}px` : 'none')};
`;
